(() => {
  const runtime = window.BogerSections;
  if (!runtime) return;
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const activateTabs = (tabs, active) => tabs.forEach(tab => {
    const selected = tab === active;
    tab.setAttribute('aria-selected', String(selected));
    tab.tabIndex = selected ? 0 : -1;
  });

  const createZoom = root => {
    const section = root.closest('.shopify-section') || root;
    const dialog = section.querySelector('[data-v2-media-dialog]');
    const image = dialog?.querySelector('[data-v2-zoom-image]');
    const title = dialog?.querySelector('[data-v2-zoom-title]');
    const count = dialog?.querySelector('[data-v2-zoom-count]');
    let items = [], index = 0, trigger = null;
    const show = next => {
      if (!items.length || !image) return;
      index = (next + items.length) % items.length;
      image.src = items[index].src;
      image.alt = items[index].alt;
      if (title) title.textContent = items[index].alt || 'Product view';
      if (count) count.textContent = `${index + 1} of ${items.length}`;
    };
    return {
      dialog,
      open(nextItems, nextIndex, nextTrigger) {
        if (!dialog || !nextItems.length) return;
        items = nextItems;
        trigger = nextTrigger;
        show(nextIndex);
        dialog.showModal();
      },
      show,
      get index() { return index; },
      close() { dialog?.close(); },
      restoreFocus() { trigger?.focus(); }
    };
  };

  runtime.register('home-journey', '[data-v2-journey]', (root, { signal }) => {
    const tabs = [...root.querySelectorAll('[data-v2-journey-tab]')];
    if (!tabs.length) return;
    const stage = root.querySelector('[data-v2-journey-stage]');
    const image = root.querySelector('[data-v2-journey-image]');
    const label = root.querySelector('[data-v2-journey-label]');
    const name = root.querySelector('[data-v2-journey-name]');
    const copy = root.querySelector('[data-v2-journey-copy]');
    const link = root.querySelector('[data-v2-journey-link]');
    const select = tab => {
      activateTabs(tabs, tab);
      if (stage) stage.dataset.activeKey = tab.dataset.key || '';
      if (image) {
        image.src = tab.dataset.image;
        image.alt = tab.dataset.name || '';
        image.dataset.fit = tab.dataset.fit || 'contain';
      }
      if (label) label.textContent = tab.dataset.label || '';
      if (name) name.textContent = tab.dataset.name || '';
      if (copy) copy.textContent = tab.dataset.copy || '';
      if (link) { link.textContent = tab.dataset.linkText || ''; link.href = tab.dataset.link || '#'; }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab), { signal });
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[next].focus();
        select(tabs[next]);
      }, { signal });
    });
    (root.closest('.shopify-section') || document).querySelectorAll('[data-home-role]').forEach(linkNode => {
      linkNode.addEventListener('click', () => {
        const tab = tabs.find(item => item.dataset.key === linkNode.dataset.homeRole);
        if (tab) select(tab);
      }, { signal });
    });
    select(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
  });

  runtime.register('collection-tabs', '[data-v2-catalogue]', (root, { signal }) => {
    const tabs = [...root.querySelectorAll('[data-v2-catalogue-tab]')];
    if (!tabs.length) return;
    const targets = {
      image: root.querySelector('[data-v2-catalogue-image]'),
      role: root.querySelector('[data-v2-catalogue-role]'),
      name: root.querySelector('[data-v2-catalogue-name]'),
      summary: root.querySelector('[data-v2-catalogue-summary]'),
      description: root.querySelector('[data-v2-catalogue-description]'),
      price: root.querySelector('[data-v2-catalogue-price]'),
      link: root.querySelector('[data-v2-catalogue-link]')
    };
    const select = tab => {
      activateTabs(tabs, tab);
      root.dataset.catalogueKey = tab.dataset.key || '';
      if (targets.image) { targets.image.src = tab.dataset.image; targets.image.alt = tab.dataset.name || ''; }
      ['role', 'name', 'summary', 'description'].forEach(key => { if (targets[key]) targets[key].textContent = tab.dataset[key] || ''; });
      if (targets.price) {
        targets.price.textContent = tab.dataset.price || '';
        targets.price.classList.toggle('is-hidden', !tab.dataset.price);
      }
      if (targets.link && tab.dataset.link) targets.link.href = tab.dataset.link;
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab), { signal });
      tab.addEventListener('keydown', event => {
        if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const forward = ['ArrowDown', 'ArrowRight'].includes(event.key);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (forward ? 1 : -1) + tabs.length) % tabs.length;
        tabs[next].focus();
        select(tabs[next]);
      }, { signal });
    });
    select(tabs[0]);
  });

  runtime.register('product-primary-gallery', '[data-v2-primary-gallery]', (root, { signal }) => {
    const cards = [...root.querySelectorAll('[data-v2-gallery-card]')];
    if (!cards.length) return;
    const count = root.querySelector('[data-v2-gallery-count]');
    const title = root.querySelector('[data-v2-gallery-title]');
    const image = root.querySelector('[data-v2-gallery-image]');
    const description = root.querySelector('[data-v2-gallery-description]');
    const source = root.querySelector('[data-v2-gallery-source]');
    const stage = root.querySelector('.gallery-stage');
    const zoom = createZoom(root);
    let index = 0;
    let componentPreview = null;
    let pointerStart = null;
    const select = (next, scrollCard = true) => {
      componentPreview = null;
      index = (next + cards.length) % cards.length;
      cards.forEach((card, cardIndex) => card.setAttribute('aria-pressed', String(cardIndex === index)));
      if (scrollCard) cards[index].scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      if (count) count.textContent = `${index + 1} of ${cards.length}`;
      if (title) title.textContent = cards[index].dataset.title || cards[index].dataset.alt || '';
      if (image) { image.src = cards[index].dataset.src; image.alt = cards[index].dataset.alt || ''; }
      if (description) description.textContent = cards[index].dataset.description || '';
      if (source) {
        const label = source.querySelector('strong')?.textContent || '';
        source.replaceChildren();
        if (label) { const strong = document.createElement('strong'); strong.textContent = label; source.append(strong, ' '); }
        source.append(cards[index].dataset.source || '');
      }
    };
    root.addEventListener('bp:bundle-media-select', event => {
      const item = event.detail;
      if (!item?.src || !image) return;
      componentPreview = { src: item.src, alt: item.alt || item.title || 'Selected component' };
      cards.forEach(card => card.setAttribute('aria-pressed', 'false'));
      image.src = componentPreview.src;
      image.alt = componentPreview.alt;
      if (title) title.textContent = item.title || componentPreview.alt;
      if (count) count.textContent = 'Component preview';
      if (description) description.textContent = '';
      if (source) source.textContent = '';
    }, { signal });
    cards.forEach((card, cardIndex) => card.addEventListener('click', () => select(cardIndex), { signal }));
    root.querySelector('[data-v2-gallery-prev]')?.addEventListener('click', () => select(index - 1), { signal });
    root.querySelector('[data-v2-gallery-next]')?.addEventListener('click', () => select(index + 1), { signal });
    stage?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      select(event.key === 'Home' ? 0 : event.key === 'End' ? cards.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
    }, { signal });
    stage?.addEventListener('pointerdown', event => { pointerStart = { x: event.clientX, y: event.clientY, id: event.pointerId }; }, { signal, passive: true });
    stage?.addEventListener('pointerup', event => {
      if (!pointerStart || pointerStart.id !== event.pointerId) return;
      const dx = event.clientX - pointerStart.x, dy = event.clientY - pointerStart.y;
      pointerStart = null;
      if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.2) select(index + (dx < 0 ? 1 : -1));
    }, { signal, passive: true });
    stage?.addEventListener('pointercancel', () => { pointerStart = null; }, { signal });
    root.querySelector('[data-v2-open-zoom]')?.addEventListener('click', event => {
      if (componentPreview) zoom.open([componentPreview], 0, event.currentTarget);
      else zoom.open(cards.map(card => ({ src: card.dataset.src, alt: card.dataset.alt || '' })), index, event.currentTarget);
    }, { signal });
    zoom.dialog?.querySelector('[data-v2-close-zoom]')?.addEventListener('click', () => zoom.close(), { signal });
    zoom.dialog?.querySelector('[data-v2-zoom-prev]')?.addEventListener('click', () => zoom.show(zoom.index - 1), { signal });
    zoom.dialog?.querySelector('[data-v2-zoom-next]')?.addEventListener('click', () => zoom.show(zoom.index + 1), { signal });
    zoom.dialog?.addEventListener('close', () => zoom.restoreFocus(), { signal });
    zoom.dialog?.addEventListener('click', event => { if (event.target === zoom.dialog) zoom.close(); }, { signal });
    select(Math.max(0, cards.findIndex(card => card.getAttribute('aria-pressed') === 'true')), false);
  });

  runtime.register('product-role-explorer', '[data-v2-role-explorer]', (root, { signal }) => {
    const tabs = [...root.querySelectorAll('[data-v2-role-tab]')];
    const panels = [...root.querySelectorAll('[data-v2-role-panel]')];
    if (!tabs.length || !panels.length) return;
    const zoom = createZoom(root);
    const select = tab => {
      activateTabs(tabs, tab);
      panels.forEach(panel => {
        const active = panel.dataset.v2RolePanel === tab.dataset.v2RoleTab;
        panel.classList.toggle('is-hidden', !active);
        panel.hidden = !active;
      });
    };
    tabs.forEach((tab, tabIndex) => {
      tab.addEventListener('click', () => select(tab), { signal });
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (tabIndex + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[next].focus();
        select(tabs[next]);
      }, { signal });
    });
    panels.forEach(panel => {
      const image = panel.querySelector('[data-v2-role-image]');
      const thumbs = [...panel.querySelectorAll('[data-v2-role-thumb]')];
      const viewTitle = panel.querySelector('[data-v2-role-title]');
      const viewCount = panel.querySelector('[data-v2-role-count]');
      let imageIndex = 0;
      const choose = next => {
        imageIndex = (next + thumbs.length) % thumbs.length;
        if (image) { image.src = thumbs[imageIndex].dataset.src; image.alt = thumbs[imageIndex].dataset.alt || ''; }
        if (viewTitle) viewTitle.textContent = thumbs[imageIndex].dataset.alt || 'Product view';
        if (viewCount) viewCount.textContent = `${imageIndex + 1} of ${thumbs.length}`;
        thumbs.forEach((thumb, thumbIndex) => thumb.setAttribute('aria-current', String(thumbIndex === imageIndex)));
      };
      thumbs.forEach((thumb, thumbIndex) => thumb.addEventListener('click', () => choose(thumbIndex), { signal }));
      panel.querySelector('[data-v2-role-zoom]')?.addEventListener('click', event => zoom.open(thumbs.map(thumb => ({ src: thumb.dataset.src, alt: thumb.dataset.alt || '' })), imageIndex, event.currentTarget), { signal });
      panel.querySelector('[data-v2-role-prev]')?.addEventListener('click', () => choose(imageIndex - 1), { signal });
      panel.querySelector('[data-v2-role-next]')?.addEventListener('click', () => choose(imageIndex + 1), { signal });
      panel.querySelector('.gallery-stage')?.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        choose(imageIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
    });
    zoom.dialog?.querySelector('[data-v2-close-zoom]')?.addEventListener('click', () => zoom.close(), { signal });
    zoom.dialog?.querySelector('[data-v2-zoom-prev]')?.addEventListener('click', () => zoom.show(zoom.index - 1), { signal });
    zoom.dialog?.querySelector('[data-v2-zoom-next]')?.addEventListener('click', () => zoom.show(zoom.index + 1), { signal });
    zoom.dialog?.addEventListener('close', () => zoom.restoreFocus(), { signal });
    select(tabs[0]);
  });

  runtime.register('product-role-jumps', '[data-v2-role-jumps]', (root, { signal }) => {
    root.querySelectorAll('[data-v2-role-jump]').forEach(button => button.addEventListener('click', () => {
      const explorer = document.querySelector('[data-v2-role-explorer]');
      const tab = explorer?.querySelector(`[data-v2-role-tab="${CSS.escape(button.dataset.v2RoleJump)}"]`);
      if (!tab) return;
      tab.click();
      explorer.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth' });
      tab.focus();
    }, { signal }));
  });

  runtime.register('product-size-tool', '[data-v2-size-tool]', (root, { signal }) => {
    const form = root.querySelector('[data-v2-fit-form]');
    const neck = form?.elements.neck;
    const chest = form?.elements.chest;
    const result = root.querySelector('.fit-result');
    if (!form || !neck || !chest || !result) return;
    let unit = 'cm';
    const convert = value => unit === 'in' ? value * 2.54 : value;
    const display = value => unit === 'in' ? (value / 2.54).toFixed(1) : String(value);
    root.querySelectorAll('[data-v2-size-unit]').forEach(button => button.addEventListener('click', () => {
      unit = button.dataset.v2SizeUnit;
      root.querySelectorAll('[data-v2-size-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelectorAll('[data-v2-unit-label]').forEach(item => { item.textContent = unit; });
      root.querySelectorAll('tbody td[data-cm]').forEach(cell => {
        const [a, b] = cell.dataset.cm.split('–').map(Number);
        cell.textContent = `${display(a)}–${display(b)}`;
      });
      const caption = root.querySelector('[data-v2-table-unit]');
      if (caption) caption.textContent = unit === 'cm' ? 'centimetres' : 'inches';
    }, { signal }));
    form.addEventListener('submit', event => {
      event.preventDefault();
      const selected = form.querySelector('input[type=radio]:checked');
      if (!selected || !neck.value || !chest.value) {
        result.textContent = 'Choose a size and enter both measurements to compare the supplier ranges.';
        (selected ? (!neck.value ? neck : chest) : form.querySelector('input[type=radio]'))?.focus();
        return;
      }
      const n = convert(Number(neck.value)), c = convert(Number(chest.value));
      const fits = n >= Number(selected.dataset.neckMin) && n <= Number(selected.dataset.neckMax) && c >= Number(selected.dataset.chestMin) && c <= Number(selected.dataset.chestMax);
      result.textContent = fits ? `${selected.value}: both measurements fall within the supplier reference range. Check the fit after putting the harness on and adjust before each walk.` : `${selected.value}: one or both measurements fall outside the supplier reference range. Measure again and compare both measurements before choosing.`;
    }, { signal });
  });

  runtime.register('valley-size-dialog', '[data-valley-size-dialog]', (dialog, { signal }) => {
    const section = dialog.closest('.shopify-section');
    const open = section?.querySelector('[data-valley-open-size]');
    const close = dialog.querySelector('[data-valley-close-size]');
    const guide = dialog.querySelector('[data-valley-size-guide-link]');
    open?.addEventListener('click', () => dialog.showModal(), { signal });
    close?.addEventListener('click', () => dialog.close(), { signal });
    guide?.addEventListener('click', () => dialog.close(), { signal });
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, { signal });
    dialog.addEventListener('close', () => open?.focus(), { signal });
  });
})();
